module.exports = __webpack_public_path__ + "img/Group 427323896.52a4649e.png";